<template>
  <div>
    <BaseModal :config="docModalConfig">
      <BaseDocumentMgrandDropoff
        ref="vestingDocumentMgr"
        :mgrGridQuery="filterCondition"
        :businessEvent="businessEvent"
        :transactionRecord="transactionRecord"
      ></BaseDocumentMgrandDropoff>
    </BaseModal>
  </div>
</template>

<script>
import BaseDocumentMgrandDropoff from "@/components/base/BaseDocumentMgrandDropoff.vue";
import BaseModal from "@/components/base/BaseModal.vue";

export default {
  name: "VestingDocumentDropoffForm",
  props: {
    docModalConfig: {},
    filterCondition: {},
    transactionRecord:{}
  },
  components: {
    BaseModal,
    BaseDocumentMgrandDropoff
  },
  data: function() {
    return {
      businessEvent: "Vesting"
    };
  },
  methods: {},
  mounted() {}
};
</script>
